export const getDictionaryFactory =
  <ValueType>(options: { validator?: (v: ValueType) => void } = {}) =>
  <Dict extends { [K in keyof Dict]: ValueType }>(dict: Dict) => {
    if (!import.meta.env.PROD && options.validator) {
      Object.values<ValueType>(dict).forEach(options.validator);
    }
    return dict;
  };
